import {createSelector} from "@reduxjs/toolkit";
import {AppState} from "../../../../newShared/redux/rootReducer";

export const notificationsSelector = createSelector((state: AppState) => state.snack.notifications, (x => x));
export const alertsSelector = createSelector((state: AppState) => state.snack.alertNotifications, (x => x));
